import { useTranslate } from "@similarweb/i18n-provider";

import { createMonthlyTimeString, createWeeklyTimeString } from "../helpers/dateHelpers";
import { BenchmarkGranularity } from "../services/api/constants";

export const useFormattedDuration = (granularity: BenchmarkGranularity, duration?: string) => {
    const { getLocale } = useTranslate();
    const language = getLocale()?.slice(0, 2);

    return granularity === BenchmarkGranularity.WEEKLY
        ? createWeeklyTimeString(language, duration)
        : createMonthlyTimeString(language, duration);
};
